export interface ResponsiveImageSource {
  srcSet: string
  type: 'image/webp'
}

const optimizedPath = (filename: string, width: number) =>
  `/assets/optimized/images/${filename}-${width}.webp ${width}w`

const webpSource = (
  filename: string,
  widths: readonly number[],
): ResponsiveImageSource => ({
  srcSet: widths.map((width) => optimizedPath(filename, width)).join(', '),
  type: 'image/webp',
})

export const responsiveImages: Readonly<
  Record<string, readonly ResponsiveImageSource[]>
> = {
  '/assets/images/图片生成-1786619095815.png': [
    webpSource('图片生成-1786619095815', [480, 960, 1440, 1920]),
  ],
  '/assets/images/夜晚-1786640317516.png': [
    webpSource('夜晚-1786640317516', [480, 960, 1440, 1920]),
  ],
  '/assets/images/图片生成-1786623775027.png': [
    webpSource('图片生成-1786623775027', [480, 960, 1440, 1920]),
  ],
  '/assets/images/图片生成-1786624684746.png': [
    webpSource('图片生成-1786624684746', [480, 960, 1440, 1920]),
  ],
  '/assets/images/图片生成-1786634866097.png': [
    webpSource('图片生成-1786634866097', [480, 768]),
  ],
  '/assets/images/图片生成-1786688708236.png': [
    webpSource('图片生成-1786688708236', [480, 960, 1440]),
  ],
  '/assets/images/图片生成-1786690380661.png': [
    webpSource('图片生成-1786690380661', [480, 960, 1440]),
  ],
  '/assets/images/微信图片_20260814160317_80_2.jpg': [
    webpSource('微信图片_20260814160317_80_2', [480, 960, 1440]),
  ],
  '/assets/images/微信图片_20260814160316_79_2.jpg': [
    webpSource('微信图片_20260814160316_79_2', [480, 960, 1440]),
  ],
  '/assets/images/图片生成-1786620485737.png': [
    webpSource('图片生成-1786620485737', [480, 960, 1440]),
  ],
  '/assets/images/图片生成-1786620254944.png': [
    webpSource('图片生成-1786620254944', [480, 960, 1440]),
  ],
}
